module.exports = __webpack_public_path__ + "img/rule-5-shelftocker.44dbb006.png";